/* unplugin-vue-components disabled */import { render } from "./DataInformation.vue?vue&type=template&id=06971341&scoped=true"
import script from "./DataInformation.vue?vue&type=script&lang=js"
export * from "./DataInformation.vue?vue&type=script&lang=js"

import "./DataInformation.vue?vue&type=style&index=0&id=06971341&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06971341"]])

export default __exports__